import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import serializeRequestError from '@rsos/utils/serializeRequestError';
import fetchRetry from '../../fetchRetry';
import {
  GET_PSAP_INFO_START,
  GET_PSAP_INFO_SUCCESS,
  GET_PSAP_INFO_FAILED,
} from '../actionTypes';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const getPSAPInfoStart = () => ({
  type: GET_PSAP_INFO_START,
});

export const getPSAPInfoSuccess = psapInfo => {
  return {
    type: GET_PSAP_INFO_SUCCESS,
    psapInfo,
  };
};

export const getPSAPInfoFail = error => {
  return {
    type: GET_PSAP_INFO_FAILED,
    error,
  };
};

export const getPSAPInfo = psapName => (dispatch, getState) => {
  dispatch(getPSAPInfoStart());
  return fetchRetry(`${baseURL}/psaps/${psapName}`)
    .then(checkStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(getPSAPInfoSuccess(response));
    })
    .catch(async err => {
      const { sinatra } = getState();
      const { tokens } = sinatra.auth;
      const { tokenExpiration, refreshExpiration } = tokens;
      captureExceptionWithScope(err, {
        extra: {
          accessTokenExpiration: tokenExpiration,
          refreshTokenExpiration: refreshExpiration,
        },
      });
      const serializedError = await serializeRequestError(err);
      throw dispatch(getPSAPInfoFail(serializedError));
    });
};

export default getPSAPInfo;
